import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const CartContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/CartContainer" */
      './CartContainer.dynamic'
    ),
});
